/**
 * 公園名と機能名だけのトップバー
 * 設定系画面で使用 (日付の選択が不要なもの)
 * @param props
 * @returns
 */
export const SimpleTopBar = (props: { parkName: string; pageTitle: string }) => {
  return (
    <div className="my-3 ms-2 d-flex align-items-center" style={{ minWidth: "200px" }}>
      <span className="h3">
        {props.parkName} : {props.pageTitle}
      </span>
    </div>
  );
};
